const actionTypes = require('../../actionTypes.js');
const stateBuilder = require("../../stateBuilder.js")

module.exports.createAction = function (categoryIndex)
{
    return (
        {
            type: actionTypes.menuCategoryIndex,
            payload: categoryIndex
        }
    );
}

module.exports.changeState = function (previousState, payload)
{
    if (payload == null)
        return stateBuilder.createState();
    else
        return Object.assign({}, previousState, { currentMenuCategoryIndex: payload });
}